import type { WatchHandle } from 'vue';

export default <T>(key: Ref<string>, handler: () => Promise<T>) => {
  const cachedKey = ref<string | null>(null);
  const watchHandle = shallowRef<WatchHandle>();
  const data = ref<T>();

  const refresh = async () => {
    data.value = await handler();
    cachedKey.value = key.value;
  };

  const subscribe = () => {
    watchHandle.value = watch(key, () => {
      void refresh();
    });

    if (cachedKey.value !== key.value) {
      void refresh();
    }
  };

  const unsubscribe = () => {
    watchHandle.value?.stop();
  };

  return {
    data,
    subscribe,
    unsubscribe,
  };
};
